
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[storeSlug]",
      function () {
        return require("private-next-pages/[storeSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[storeSlug]"])
      });
    }
  